// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TablePagination,
//   Switch,
//   IconButton,
//   Button,
//   Typography,
//   CircularProgress,
//   Alert,
//   Menu,
//   MenuItem,
//   Chip,
//   TextField,
//   InputAdornment,
// } from '@mui/material';
// import { MoreVert, Add, Search } from '@mui/icons-material';
// import AddEditDialog from './components/AddEditDialog';
// import DeleteDialog from './components/DeleteDialog';
// import httpclient from '../../Utils';

// const Permission = () => {
//   const [permissions, setPermissions] = useState([]);
//   const [filteredPermissions, setFilteredPermissions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(20);
//   const [total, setTotal] = useState(0);
  
//   // Dialog states
//   const [openAddEdit, setOpenAddEdit] = useState(false);
//   const [openDelete, setOpenDelete] = useState(false);
//   const [selectedPermission, setSelectedPermission] = useState(null);
//   const [dialogMode, setDialogMode] = useState('add'); // 'add' or 'edit'
  
//   // Menu state for 3-dot actions
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [menuPermission, setMenuPermission] = useState(null);

//   // Fetch permissions from API
//   const fetchPermissions = () => {
//     setLoading(true);
//     setError(null);
//     httpclient
//       .get(`permissions?page=${page + 1}&per_page=${rowsPerPage}`)
//       .then(({ data }) => {
//         if (data.status === 200) {
//           setPermissions(data.data);
//           setFilteredPermissions(data.data);
//           setTotal(data.meta.total);
//           setRowsPerPage(parseInt(data.meta.per_page));
//           setPage(data.meta.current_page - 1);
//           setLoading(false);
//         } else {
//           setError(data.message || 'Failed to fetch permissions');
//           setLoading(false);
//         }
//       })
//       .catch((err) => {
//         setError(err.response?.data?.message || 'An error occurred');
//         setLoading(false);
//       });
//   };

//   useEffect(() => {
//     fetchPermissions();
//   }, [page, rowsPerPage]);

//   // Search functionality
//   useEffect(() => {
//     if (searchTerm === '') {
//       setFilteredPermissions(permissions);
//     } else {
//       const filtered = permissions.filter((permission) =>
//         permission.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         permission.menu.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//       setFilteredPermissions(filtered);
//     }
//   }, [searchTerm, permissions]);

//   // Handle toggle status
//   const handleToggleStatus = (permission) => {
//     const newStatus = permission.status === 1 ? 0 : 1;
//     httpclient
//       .put(`permissions/${permission.id}`, { status: newStatus })
//       .then(({ data }) => {
//         if (data.status === 200) {
//           // Update local state
//           setPermissions(prev =>
//             prev.map(p =>
//               p.id === permission.id ? { ...p, status: newStatus } : p
//             )
//           );
//         }
//       })
//       .catch((err) => {
//         setError('Failed to update status');
//       });
//   };

//   // Handle menu open
//   const handleMenuOpen = (event, permission) => {
//     setAnchorEl(event.currentTarget);
//     setMenuPermission(permission);
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//     setMenuPermission(null);
//   };

//   // Edit action
//   const handleEdit = () => {
//     setSelectedPermission(menuPermission);
//     setDialogMode('edit');
//     setOpenAddEdit(true);
//     handleMenuClose();
//   };

//   // Delete action
//   const handleDeleteClick = () => {
//     setSelectedPermission(menuPermission);
//     setOpenDelete(true);
//     handleMenuClose();
//   };

//   // Confirm delete
//   const handleConfirmDelete = () => {
//     httpclient
//       .delete(`permissions/${selectedPermission.id}`)
//       .then(({ data }) => {
//         if (data.status === 200) {
//           fetchPermissions(); // Refresh list
//           setOpenDelete(false);
//           setSelectedPermission(null);
//         } else {
//           setError('Failed to delete permission');
//         }
//       })
//       .catch((err) => {
//         setError('Failed to delete permission');
//       });
//   };

//   // Add new permission
//   const handleAddClick = () => {
//     setSelectedPermission(null);
//     setDialogMode('add');
//     setOpenAddEdit(true);
//   };

//   // Close add/edit dialog
//   const handleCloseAddEdit = (refresh = false) => {
//     setOpenAddEdit(false);
//     setSelectedPermission(null);
//     if (refresh) fetchPermissions();
//   };

//   // Handle page change
//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       {/* Header */}
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//         <Box>
//           <Typography variant="h4" component="h1" gutterBottom>
//             Permissions
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             View all system permissions available for roles and users.
//           </Typography>
//         </Box>
//         <Button
//           variant="contained"
//           color="success"
//           startIcon={<Add />}
//           onClick={handleAddClick}
//           sx={{ textTransform: 'none' }}
//         >
//           Add Permission
//         </Button>
//       </Box>

//       {/* Search Bar */}
//       <Box sx={{ mb: 2 }}>
//         <TextField
//           size="small"
//           placeholder="Search by permission name or menu..."
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <Search />
//               </InputAdornment>
//             ),
//           }}
//           sx={{ width: 300 }}
//         />
//       </Box>

//       {/* Error Alert */}
//       {error && (
//         <Alert severity="error" onClose={() => setError(null)} sx={{ mb: 2 }}>
//           {error}
//         </Alert>
//       )}

//       {/* Table */}
//       <Paper sx={{ width: '100%', overflow: 'hidden' }}>
//         <TableContainer sx={{ maxHeight: 'calc(100vh - 250px)' }}>
//           <Table stickyHeader>
//             <TableHead>
//               <TableRow>
//                 <TableCell><strong>Permission Name</strong></TableCell>
//                 <TableCell><strong>Menu</strong></TableCell>
//                 <TableCell align="center"><strong>Status</strong></TableCell>
//                 <TableCell align="center"><strong>Actions</strong></TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {loading ? (
//                 <TableRow>
//                   <TableCell colSpan={4} align="center" sx={{ py: 5 }}>
//                     <CircularProgress />
//                   </TableCell>
//                 </TableRow>
//               ) : filteredPermissions.length === 0 ? (
//                 <TableRow>
//                   <TableCell colSpan={4} align="center" sx={{ py: 5 }}>
//                     <Typography color="text.secondary">No permissions found</Typography>
//                   </TableCell>
//                 </TableRow>
//               ) : (
//                 filteredPermissions.map((permission) => (
//                   <TableRow key={permission.id} hover>
//                     <TableCell>{permission.name}</TableCell>
//                     <TableCell>
//                       <Chip label={permission.menu} size="small" variant="outlined" />
//                     </TableCell>
//                     <TableCell align="center">
//                       <Switch
//                         checked={permission.status === 1}
//                         onChange={() => handleToggleStatus(permission)}
//                         color="success"
//                       />
//                     </TableCell>
//                     <TableCell align="center">
//                       <IconButton onClick={(e) => handleMenuOpen(e, permission)}>
//                         <MoreVert />
//                       </IconButton>
//                     </TableCell>
//                   </TableRow>
//                 ))
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         {/* Pagination */}
//         <TablePagination
//           rowsPerPageOptions={[10, 20, 50]}
//           component="div"
//           count={total}
//           rowsPerPage={rowsPerPage}
//           page={page}
//           onPageChange={handleChangePage}
//           onRowsPerPageChange={handleChangeRowsPerPage}
//         />
//       </Paper>

//       {/* Action Menu */}
//       <Menu
//         anchorEl={anchorEl}
//         open={Boolean(anchorEl)}
//         onClose={handleMenuClose}
//       >
//         <MenuItem onClick={handleEdit}>Edit</MenuItem>
//         <MenuItem onClick={handleDeleteClick} sx={{ color: 'error.main' }}>
//           Delete
//         </MenuItem>
//       </Menu>

//       {/* Add/Edit Dialog */}
//       <AddEditDialog
//         open={openAddEdit}
//         onClose={handleCloseAddEdit}
//         permission={selectedPermission}
//         mode={dialogMode}
//       />

//       {/* Delete Dialog */}
//       <DeleteDialog
//         open={openDelete}
//         onClose={() => setOpenDelete(false)}
//         onConfirm={handleConfirmDelete}
//         permissionName={selectedPermission?.name}
//       />
//     </Box>
//   );
// };

// export default Permission;



import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Switch,
  IconButton,
  Button,
  Typography,
  CircularProgress,
  Alert,
  Menu,
  MenuItem,
  TextField,
  InputAdornment,
} from '@mui/material';
import { MoreVert, Add, Search } from '@mui/icons-material';
import AddEditDialog from './components/AddEditDialog';
import DeleteDialog from './components/DeleteDialog';
import httpclient from '../../Utils';

const Permission = () => {
  const [permissions, setPermissions] = useState([]);
  const [filteredPermissions, setFilteredPermissions] = useState([]);
  const [menuList, setMenuList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [total, setTotal] = useState(0);
  
  // Dialog states
  const [openAddEdit, setOpenAddEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedPermission, setSelectedPermission] = useState(null);
  const [dialogMode, setDialogMode] = useState('add'); // 'add' or 'edit'
  
  // Menu state for 3-dot actions
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuPermission, setMenuPermission] = useState(null);

  // Fetch permissions from API
  const fetchPermissions = useCallback(() => {
    setLoading(true);
    setError(null);
    httpclient
      .get(`permissions?page=${page + 1}&per_page=${rowsPerPage}`)
      .then(({ data }) => {
        if (data.responseCode === 200 && data.success) {
          setPermissions(data.data);
          setFilteredPermissions(data.data);
          setTotal(data.meta?.total || data.count || data.data.length);
          setLoading(false);
        } else {
          setError(data.message || 'Failed to fetch permissions');
          setLoading(false);
        }
      })
      .catch((err) => {
        setError(err.response?.data?.message || 'An error occurred');
        setLoading(false);
      });
  }, [page, rowsPerPage]);

  // Fetch menu list from API
  const fetchMenus = useCallback(() => {
    httpclient
      .get('menus') // Adjust this endpoint based on your API
      .then(({ data }) => {
        if (data.responseCode === 200 && data.data) {
          setMenuList(data.data);
        } else if (data.menuList) {
          // Alternative response structure
          setMenuList(data.menuList);
        }
      })
      .catch((err) => {
        console.error('Failed to fetch menus:', err);
        setMenuList([]);
      });
  }, []);

  useEffect(() => {
    fetchPermissions();
  }, [fetchPermissions]);

  useEffect(() => {
    fetchMenus();
  }, [fetchMenus]);

  // Search functionality
  useEffect(() => {
    if (searchTerm === '') {
      setFilteredPermissions(permissions);
    } else {
      const filtered = permissions.filter((permission) =>
        permission.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredPermissions(filtered);
    }
  }, [searchTerm, permissions]);

  // Handle toggle status
  const handleToggleStatus = (permission) => {
    const newStatus = permission.status === 1 ? 0 : 1;
    httpclient
      .put(`permissions/${permission.id}`, { status: newStatus })
      .then(({ data }) => {
        if (data.responseCode === 200 && data.success) {
          // Update local state
          setPermissions(prev =>
            prev.map(p =>
              p.id === permission.id ? { ...p, status: newStatus } : p
            )
          );
        } else {
          setError('Failed to update status');
        }
      })
      .catch((err) => {
        setError('Failed to update status');
      });
  };

  // Handle menu open
  const handleMenuOpen = (event, permission) => {
    setAnchorEl(event.currentTarget);
    setMenuPermission(permission);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuPermission(null);
  };

  // Edit action
  const handleEdit = () => {
    setSelectedPermission(menuPermission);
    setDialogMode('edit');
    setOpenAddEdit(true);
    handleMenuClose();
  };

  // Delete action
  const handleDeleteClick = () => {
    setSelectedPermission(menuPermission);
    setOpenDelete(true);
    handleMenuClose();
  };

  // Confirm delete
  const handleConfirmDelete = () => {
    httpclient
      .delete(`permissions/${selectedPermission.id}`)
      .then(({ data }) => {
        if (data.responseCode === 200 && data.success) {
          fetchPermissions(); // Refresh list
          setOpenDelete(false);
          setSelectedPermission(null);
        } else {
          setError('Failed to delete permission');
        }
      })
      .catch((err) => {
        setError('Failed to delete permission');
      });
  };

  // Add new permission
  const handleAddClick = () => {
    setSelectedPermission(null);
    setDialogMode('add');
    setOpenAddEdit(true);
  };

  // Close add/edit dialog
  const handleCloseAddEdit = (refresh = false) => {
    setOpenAddEdit(false);
    setSelectedPermission(null);
    if (refresh) fetchPermissions();
  };

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box sx={{ p: 3 }}>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h4" component="h1" gutterBottom>
            Permissions
          </Typography>
          <Typography variant="body2" color="text.secondary">
            View all system permissions available for roles and users.
          </Typography>
        </Box>
        <Button
          variant="contained"
          color="success"
          startIcon={<Add />}
          onClick={handleAddClick}
          sx={{ textTransform: 'none' }}
        >
          Add Permission
        </Button>
      </Box>

      {/* Search Bar */}
      <Box sx={{ mb: 2 }}>
        <TextField
          size="small"
          placeholder="Search by permission name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
          sx={{ width: 300 }}
        />
      </Box>

      {/* Error Alert */}
      {error && (
        <Alert severity="error" onClose={() => setError(null)} sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {/* Table */}
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer sx={{ maxHeight: 'calc(100vh - 250px)' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell><strong>Permission Name</strong></TableCell>
                <TableCell align="center"><strong>Status</strong></TableCell>
                <TableCell align="center"><strong>Actions</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={3} align="center" sx={{ py: 5 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : filteredPermissions.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={3} align="center" sx={{ py: 5 }}>
                    <Typography color="text.secondary">No permissions found</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                filteredPermissions.map((permission) => (
                  <TableRow key={permission.id} hover>
                    <TableCell>{permission.name}</TableCell>
                    <TableCell align="center">
                      <Switch
                        checked={permission.status === 1}
                        onChange={() => handleToggleStatus(permission)}
                        color="success"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <IconButton onClick={(e) => handleMenuOpen(e, permission)}>
                        <MoreVert />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          rowsPerPageOptions={[10, 20, 50]}
          component="div"
          count={total}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      {/* Action Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleEdit}>Edit</MenuItem>
        <MenuItem onClick={handleDeleteClick} sx={{ color: 'error.main' }}>
          Delete
        </MenuItem>
      </Menu>

      {/* Add/Edit Dialog */}
      <AddEditDialog
        open={openAddEdit}
        onClose={handleCloseAddEdit}
        permission={selectedPermission}
        mode={dialogMode}
        menuList={menuList}
      />

      {/* Delete Dialog */}
      <DeleteDialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onConfirm={handleConfirmDelete}
        permissionName={selectedPermission?.name}
      />
    </Box>
  );
};

export default Permission;